import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface CommunicationExplorerState {
  isCommunicationExplorerViewApiLoaded: boolean;
}

const initialState: CommunicationExplorerState = {
  isCommunicationExplorerViewApiLoaded: false,
};

const communicationExplorerSlice = createSlice({
  name: 'communicationExplorer',
  initialState,
  reducers: {
    setCommunicationExplorerViewApiLoaded(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isCommunicationExplorerViewApiLoaded = action.payload;
    },
  },
});

export const {setCommunicationExplorerViewApiLoaded} =
  communicationExplorerSlice.actions;
export default communicationExplorerSlice.reducer;
